package com.evoapps.evoshift.domain.repository

import com.evoapps.evoshift.domain.legal.LegalCalendarYear
import com.evoapps.evoshift.domain.legal.LegalCalendars

/**
 * The legal calendars (SH-55): Firestore `legal_calendars/{country}_{year}`, readable by anyone
 * signed in, written only by scripts/legal/seed_legal_calendar.js (Admin SDK).
 */
interface LegalCalendarRepository {
    /** The stored calendar, or null when there is none for that year. */
    suspend fun getYear(country: String, year: Int): Result<LegalCalendarYear?>
}

/** Only the copy shipped with the app (tests, and the app before Firestore answers). */
object BundledLegalCalendarRepository : LegalCalendarRepository {
    override suspend fun getYear(country: String, year: Int): Result<LegalCalendarYear?> =
        Result.success(LegalCalendars.bundled(country, year))
}
